import { render, staticRenderFns } from "./registro_edicion_tipo_reportes.vue?vue&type=template&id=a891c784&scoped=true"
import script from "./registro_edicion_tipo_reportes.vue?vue&type=script&lang=js"
export * from "./registro_edicion_tipo_reportes.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_tipo_reportes.vue?vue&type=style&index=0&id=a891c784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a891c784",
  null
  
)

export default component.exports